import '@ungap/custom-elements';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import Vuelidate from 'vuelidate';
import ZipCta from './ZipCta';

Vue.use(Vuelidate);
Vue.use(vueCustomElement);

// Additional Options: https://github.com/karol-f/vue-custom-element#options
// NOTE: at the moment shadowDOM is disabled in webpack for widgets,
// this is due to pollyfills like shadyDOM not working in IE11
Vue.customElement('zip-cta', ZipCta);
